/**
 * Auth lifecycle events.
 *
 * Deliberately dependency-free so any module can subscribe without pulling in the
 * API barrel (and, through it, the store).
 *
 * The access token is never carried on the event — subscribers re-read it from the
 * cookie. Credentials stay out of anything that observes these notifications.
 */

type TokenRefreshListener = () => void;

const tokenRefreshListeners = new Set<TokenRefreshListener>();

/**
 * Subscribe to access-token refreshes. Returns an unsubscribe function.
 *
 * Needed by anything that caches the access token outside the cookie — notably the
 * heartbeat Web Worker, which holds its own copy and cannot see the cookie update.
 */
export function subscribeToTokenRefresh(listener: TokenRefreshListener): () => void {
  tokenRefreshListeners.add(listener);
  return () => {
    tokenRefreshListeners.delete(listener);
  };
}

/** Announce that the access token in the cookie has been replaced. */
export function emitTokenRefreshed(): void {
  tokenRefreshListeners.forEach(listener => listener());
}
